<template>
    <div class="wrapper-div">
        <div
            class="customButton backgroundColor=000000 foregroundColor=fff wistia_channel wistia_async_jdcts51v2e mode=inline"
        ></div>
    </div>
    <!-- built files will be auto injected -->
    <!-- This works as a way to inline modify:
            class="customButton backgroundColor=000000 foregroundColor=fff wistia_channel wistia_async_jdcts51v2e mode=inline"
    -->
</template>

<!-- See https://wistia.com/support/developers/embed-options for new Wistia embed customization details
    and https://wistia.com/support/developers/player-api for window push -->

<script>
// Services
import AnalyticService from '~/services/AnalyticService';

export default {
    name: 'Resources',
    mounted() {
        AnalyticService.impressionEvent(
            AnalyticService.IMPRESSION_ACTIONS.MASTERCLASSES_VIEW_ACTION
        );
    },
};
</script>

<style>
.wrapper-div {
    position: absolute;
    top: 70px;
    left: 0;
    padding-bottom: -60px;
    z-index: 0;
    width: 100vw;
    height: calc(100vh - 60px);
    overflow-x: hidden;
}

.w-gallery-overlay {
    position: absolute;
    top: 60px !important;
    left: 0;
    z-index: 100;
    width: 100vw;
    height: calc(100vh - 60px) !important;
}

.w-big-play-button {
    background-color: var(--primary) !important;
}

button.w-vulcan-v2-button {
    background-color: var(--primary) !important;
    opacity: 0.95;
}

/* Didn't get opacity to work here so we use brightness for hover instead */
button.w-vulcan-v2-button:hover {
    filter: brightness(120%);
}

/* Might need to revisit this - seems to have a weak main-color overlay of some sort (if you try with blue) */
.w-playbar-wrapper {
    background: var(--primary) !important;
    opacity: 0.85;
}

.w-playing-indicator {
    background-color: var(--primary) !important;
    opacity: 0.6;
}

.wistia_channel {
    width: 100%;
    height: 100%;
    background-color: #000;
}

button.w-channel-big-button {
    background-color: var(--primary) !important;
}

button.w-channel-big-button:hover {
    animation: bounce 1s alternate ease-in-out infinite;
}

.w-css-reset p,
.w-css-reset h1,
.w-css-reset h3 {
    color: white !important;
}

div.w-gallery-view__hero-content > div:nth-child(3):hover {
    /*   complete in \/    delay \/ */
    animation: creep 5s forwards 30s ease-in-out;
}

@keyframes bounce {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(1.05);
    }
}

@keyframes creep {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(2.5);
    }
}

@media only screen and(max-width: 600px) {
    .wrapper-div {
        top: 60px;
    }
}
</style>
